import React, { useState, useEffect } from 'react';
import { Tabs, Table, Loader, Text } from '@mantine/core';
import { makeGetRequest } from '../services/httpHelper';
import { isErrorObject } from '../utils/utils';
import ErrorHandler from '../services/ErrorHandler';
import { IMpesaLog, IPaypalLog, IPyastackLog } from '../types';



const LogsViewer: React.FC = () => {
  const [paypalLogs, setPaypalLogs] = useState<IPaypalLog[]>([]);
  const [mpesaLogs, setMpesaLogs] = useState<IMpesaLog[]>([]);
  const [paystackLogs, setPaystackLogs] = useState<IPyastackLog[]>([]);

  const [loading, setLoading] = useState(true);
  const[error,setError]=useState(null)

  


  useEffect(() => {
    const getPosts = async () => {
        setLoading(true);
      const res = await makeGetRequest('paypal-logs');
      if (isErrorObject(res)) {
        console.log(error);
        setError(ErrorHandler(res));
      } else {
        setPaypalLogs(res.data);
        setError(null);
        setLoading(false)
      }
    };

    const getMpesaLogs = async () => {
      setLoading(true);
    const res = await makeGetRequest('mpesa-logs');
    if (isErrorObject(res)) {
      console.log(error);
      setError(ErrorHandler(res));
    } else {
      setMpesaLogs(res.data);
      setError(null);
      setLoading(false)
    }
  };

  const getPaystackLogs = async () => {
    setLoading(true);
  const res = await makeGetRequest('paystack-logs');
  if (isErrorObject(res)) {
    console.log(error);
    setError(ErrorHandler(res));
  } else {
    setPaystackLogs(res.data);
    setError(null);
    setLoading(false)
  }
};
getMpesaLogs();
getPaystackLogs();
    getPosts();

  }, []);

  const renderJson = (data: object | null) => {
    if (!data) return <Text size="sm" color="gray">N/A</Text>;
    return <Text size="sm">{JSON.stringify(data, null, 2)}</Text>;
  };

  const renderPaypalLogs = () => (
    <Table striped highlightOnHover withBorder>
      <thead>
        <tr>
          <th>ID</th>
          <th>Amount</th>
          <th>Description</th>
          <th>Debug ID</th>
          <th>Order ID</th>
          <th>Status Code</th>
          <th>Email</th>
          <th>Request Headers</th>
          <th>Request Body</th>
          <th>Response Headers</th>
          <th>Response Body</th>
        </tr>
      </thead>
      <tbody>
        {paypalLogs.map((log) => (
          <tr key={log.id}>
            <td>{log.id}</td>
            <td>{log.amount || 'N/A'}</td>
            <td>{log.description}</td>
            <td>{log.debug_id}</td>
            <td>{log.order_id || 'N/A'}</td>
            <td>{log.status_code || 'N/A'}</td>
            <td>{log.email_address || 'N/A'}</td>
            <td>{renderJson(log.request_headers)}</td>
            <td>{renderJson(log.request_body)}</td>
            <td>{renderJson(log.response_headers)}</td>
            <td>{renderJson(log.response_body)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );


  const renderMpesaLogs = () => (
    <Table striped highlightOnHover withBorder>
      <thead>
        <tr>
          <th>Trans ID</th>
          <th>Amount</th>
          <th>Transaction Type</th>
          <th>Name</th>
          <th>MSISDN</th>
          <th>CheckoutRequest ID</th>
          <th>Currency</th>
          <th>Business Short Code</th>
          <th>Bill Ref Number</th>
          <th>ThirdParty TransID</th>
          <th>Org Acc Bal</th>
          <th>Meta Data</th>
          <th>Status</th>
          <th>Trans Time</th>
        </tr>
      </thead>
      <tbody>
        {mpesaLogs.map((log) => (
          <tr key={log.id}>
            <td>{log.transID}</td>
            <td>{log.transAmount || 'N/A'}</td>
            <td>{log.firstName} {log.lastName}</td>
            <td>{log.msisdn}</td>
            <td>{log.checkoutRequestId || 'N/A'}</td>
            <td>{log.selectedCurrency || 'N/A'}</td>
            <td>{log.businessShortCode || 'N/A'}</td>
            <td>{log.billRefNumber || 'N/A'}</td>
            <td>{log.thirdPartyTransID || 'N/A'}</td>
            <td>{log.orgAccountBalance || 'N/A'}</td>
            <td>{renderJson(log.metaData)}</td>        
            <td>{log.status || 'N/A'}</td>
            <td>{log.transTime || 'N/A'}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );


  const renderPaystackLogs = () => (
    <Table striped highlightOnHover withBorder>
      <thead>
        <tr>
          <th>Trans Id</th>
          <th>Status</th>
          <th>Amount</th>
          <th>Reference</th>
          <th>IP Address</th>
          <th>Receipt Number</th>
          <th>Donor</th>
          <th>Channel</th>
          <th>Gateway Response</th>
          <th>Message</th>
          <th>Meta Data</th>
          <th>Customer</th>          
          <th>Fees Breakdown</th>
          <th>Sub Account</th>
          <th>Auth Header</th>          
          <th>Trans Date</th>
        </tr>
      </thead>
      <tbody>
        {paystackLogs.map((log) => (
          <tr key={log.id}>
            <td>{log.transId}</td>
            <td>{log.amount || 'N/A'}</td>
            <td>{log.reference}</td>
            <td>{log.ipAddress}</td>
            <td>{log.receiptNumber || 'N/A'}</td>
            <td>{log.donor || 'N/A'}</td>
            <td>{log.gatewayResponse || 'N/A'}</td>
            <td>{log.message || 'N/A'}</td>     
            <td>{renderJson(log.metadata)}</td>
            <td>{renderJson(log.customer)}</td>  
            <td>{renderJson(log.feesBreakdown)}</td>  
            <td>{renderJson(log.subAccount)}</td>  
            <td>{renderJson(log.authorizationHeader)}</td>          
            <td>{log.transactionDate || 'N/A'}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  if (loading) return <Loader />;

  return (
    <Tabs defaultValue="paypal">
      <Tabs.List>
        <Tabs.Tab value="mpesa">Mpesa Logs</Tabs.Tab>
        <Tabs.Tab value="paypal">Paypal Logs</Tabs.Tab>
        <Tabs.Tab value="paystack">Paystack</Tabs.Tab>
      </Tabs.List>

        <Tabs.Panel value="mpesa">{renderMpesaLogs()}</Tabs.Panel>    

      <Tabs.Panel value="paypal">{renderPaypalLogs()}</Tabs.Panel>
      <Tabs.Panel value="paystack">{renderPaystackLogs()}</Tabs.Panel>


     
    </Tabs>
  );
};

export default LogsViewer;
